module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp2_6000.0f64ce92.png";